import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Hook de datos para OrderWsModalProductsMC
 * Separa la lógica de negocio y serialización de productos y totales.
 * Optimizado con useMemo.
 */
export default function useOrderWsModalProductsData(message) {
  const { t, i18n } = useTranslation('InboxMC');
  const order = useMemo(() => (
    message?.contentWsOrder ?? message?.content_ws_order ?? {}
  ), [message?.contentWsOrder, message?.content_ws_order]);

  const accountUid = message?.accountUID || message?.account_uid || 'unknown-account';

  const products = useMemo(() => {
    const list = Array.isArray(order?.products) ? order.products : [];
    return list.map((product, index) => ({
      key: `product-${accountUid}-${index}`,
      name: product.name,
      quantity: product.quantity,
      price: product.price,
      url: product.url,
    }));
  }, [order?.products, accountUid]);

  const total = useMemo(() => order?.total || 0, [order?.total]);

  const senderName = useMemo(() => (
    message?.inboundSenderFullName
      || message?.inbound_sender_full_name
      || message?.senderFullName
      || message?.sender_full_name
      || ''
  ), [
    message?.inboundSenderFullName,
    message?.inbound_sender_full_name,
    message?.senderFullName,
    message?.sender_full_name
  ]);

  const createdTime = useMemo(
    () => message?.createdTime || message?.created_time || '',
    [message?.createdTime, message?.created_time]
  );

  return {
    products,
    total,
    senderName,
    createdTime,
    t,
    i18n,
  };
}
